import { VideoPlayer, VideoPlayerProps } from "@graphland/react-video-player";

import { CustomComponentProps } from "utils/types/general.types";

export type CustomVideoPlayerProps = CustomComponentProps & {
    src: string;
};

const CustomVideoPlayer = ({
    src,
    className,
    style
}: CustomVideoPlayerProps) => {
    const videoSources = [
        {
            src: src,
            // src: "https://media.w3.org/2010/05/sintel/trailer_hd.mp4",
            type: "video/mp4"
        }
        // Add more video sources as needed
    ];

    const videoProps: VideoPlayerProps = {
        theme: "forest", // 'city', 'fantasy', 'forest', 'sea'
        height: 720,
        width: 1280,
        autoPlay: false,
        loop: false,
        sources: videoSources,
        controlBar: {
            skipButtons: {
                forward: 5,
                backward: 5
            }
        },
        playbackRates: [0.5, 1, 1.5, 2],
        disablePictureInPicture: false
        // onReady: () => {
        //     console.log("Video player is ready!");
        // }
    };

    return (
        <div className={className} style={style}>
            <VideoPlayer {...videoProps} />
        </div>
    );
};

export default CustomVideoPlayer;
